import {forwardRef} from "react";
import {useNavigate, useLocation, useParams} from "react-router-dom";

export function withRouter(Component) {
    const Wrapper = (props, ref) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();

        return (
            <Component
                {...props}
                ref={ref}
                navigate={navigate}
                location={location}
                params={params}
            />
        );
    };

    return forwardRef(Wrapper);
}
